{
  "10ffbe511de09f84": "Factura anterior",
  "24cb98ea86f38d17": "Ver factura",
  "2bc748490ad9ba4e": "{{invoiceCount}} factura",
  "359337f0a9c68324": "(revisado)",
  "37945f0742ea2cc4": "Disputar factura",
  "3a8931a9b2f6bf69": "Disputa",
  "42e9524eb188efbd": "Ver factura anterior",
  "472c6c914210d3d9": "Ver hoja de tiempo",
  "4a90e7d8d982f4c2": "Ver disputa por la factura #{{invoiceNumber}}",
  "4b80e74f3fa47867": "No pagado",
  "5b1a1186e5e400a9": "Ver disputa de factura",
  "5d906349d4fb9e4b": "Disputa: {{status}}",
  "6171b2a461207d19": "Estado de cuenta",
  "6471421a56ffde3c": "Portal de facturación",
  "6d320a315fe443f9": "Hoja de tiempo",
  "723afa394daeea97": "Pagar",
  "75b6330de57a7203": "Vencimiento {{dueDate}}",
  "79c2657890c42470": "Ver disputa",
  "8f74e5015dd26f64": "Historial de facturas",
  "91e33e3ba5c1ca1a": "Año anterior",
  "920e413c7d411b61": "Estado",
  "955b9e7a497b0ac3": "Estado de cuenta",
  "9ecae17e665870ab": "Factura #{{invoiceNumber}}",
  "a21a5dc62ee1cde3": "Año siguiente",
  "a328add3ebaecf9b": "{{invoiceCount}} facturas",
  "b1dead56e7d7adf2": "Pagar factura",
  "b4e929d8bcfe0418": "Documentos",
  "b832002da297545f": "Factura",
  "be76c803bf1ebe28": "Facturas revisadas",
  "c9b3c38247f744e1": "Total",
  "d660945bc2991320": "Atrasado",
  "dcc839a4015c4b7d": "Ver",
  "e1cb6d30fa3f17ee": "Fecha de vencimiento",
  "e1dd7ffca8e92b69": "Ver factura #{{invoiceNumber}}",
  "e5030091dc4e3004": "Ver disputa de factura anterior",
  "e6b30f9398c0725b": "Sin facturas",
  "fa094114509b07b6": "No se pudo abrir el portal de facturación. Por favor, intente de nuevo.",
  "fb81b961af456e5e": "Pagada",
  "fc799c7371bffd02": "Detalles de la factura"
}
